import React from "react";
import { Platform, ScrollView } from "react-native";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";

const KeyboardAwareScrollViewCustom = (props) => {
  // return Platform.OS === "ios" ? (
  return (
    <KeyboardAwareScrollView
      testID={props.testID}
      enableOnAndroid
      keyboardShouldPersistTaps="handled"
      contentContainerStyle={props.contentContainerStyle}
    >
      {props.children}
    </KeyboardAwareScrollView>
  );
  // ) : (
  //   <ScrollView
  //     testID={props.testID}
  //     keyboardShouldPersistTaps="handled"
  //     contentContainerStyle={props.contentContainerStyle}
  //   >
  //     {props.children}
  //   </ScrollView>
  // );
};

export default KeyboardAwareScrollViewCustom;
